const $ = require("jquery");

const preventEmptyHrefDefault = function () {
  $('a[href="#"]').on('click', (event) => event.preventDefault());
};

export { preventEmptyHrefDefault };